module.exports = __webpack_public_path__ + "img/GK9902-GK.548fd085.jpg";